module.exports = "/_next/static/fonts/FuzzyBubbles-Bold-7e19de50e1a0d53f022ac39f49c458d9.woff2";